import { from, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { dfimAxios } from '../config/Axios';
import {
  GET_ALL_AUDITS,
  getAllAuditsSuccess,
  getAllAuditsError,
  GET_USER_AUDITS,
  getUserAuditsSuccess,
  getUserAuditsError,
  GET_AUDIT_TYPES,
  getAuditTypesSuccess,
  getAuditTypesError,
} from '../actions/Audit';

const userAuditsGetRequest = (id) =>
  dfimAxios.get(`/api/audit/user/${id}`).then((response) => response.data);
const allAuditsGetRequest = () => dfimAxios.get('/api/audit/all').then((response) => response.data);
const superUserAuditsGetRequest = (id) =>
  dfimAxios.get(`/api/audit/company/${id}`).then((response) => response.data);
const auditTypesGetRequest = () =>
  dfimAxios.get('/api/audit/types').then((response) => response.data);

export const AuditsGetAllEpic = (action$) =>
  action$.pipe(
    ofType(GET_ALL_AUDITS),
    switchMap((action) =>
      from(
        action.payload.authority === 'ADMIN'
          ? allAuditsGetRequest()
          : superUserAuditsGetRequest(action.payload.company.id)
      ).pipe(
        map((data) => getAllAuditsSuccess(data)),
        catchError((error) => of(getAllAuditsError(error)))
      )
    )
  );

export const AuditsGetByIdEpic = (action$) =>
  action$.pipe(
    ofType(GET_USER_AUDITS),
    switchMap((action) =>
      from(userAuditsGetRequest(action.payload.id)).pipe(
        map((data) => getUserAuditsSuccess(data)),
        catchError((error) => of(getUserAuditsError(error)))
      )
    )
  );

export const AuditsGetTypesEpic = (action$) =>
  action$.pipe(
    ofType(GET_AUDIT_TYPES),
    switchMap(() =>
      from(auditTypesGetRequest()).pipe(
        map((data) => getAuditTypesSuccess(data)),
        catchError((error) => of(getAuditTypesError(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [AuditsGetAllEpic, AuditsGetByIdEpic, AuditsGetTypesEpic];
